module.exports = __webpack_public_path__ + "img/img_Intelligentdiagnosis_b.f06a0584.png";